import {useState, useEffect} from 'react';

interface UseScrollToProviderParams {
    existingProviderQueuedForDeletion: string | null;
}

interface UseScrollToProviderReturn {
    scrollToExistingProvider: string | null;
}

export function useScrollToProvider({
    existingProviderQueuedForDeletion
}: UseScrollToProviderParams): UseScrollToProviderReturn {
    const [scrollToExistingProvider, setScrollToExistingProvider] = useState<string | null>(null);

    useEffect(() => {
        if (existingProviderQueuedForDeletion) {
            setScrollToExistingProvider(existingProviderQueuedForDeletion);
            // Clear scroll target after scrolling to prevent interference with user scrolling
            const timer = setTimeout(() => {
                setScrollToExistingProvider(null);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [existingProviderQueuedForDeletion]);

    return {
        scrollToExistingProvider
    };
}
